import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { SelectModule } from 'primeng/select';

@Component({
  standalone: true,
  selector: 'pm-form-field-autocomplete',
  imports: [ReactiveFormsModule, SelectModule],
  templateUrl: './pm-form-field-autocomplete.component.html',
  styleUrl: './pm-form-field-autocomplete.component.scss',
})
export class PmFormFieldAutocompleteComponent extends FormFieldComponent {}
